<ng-content select="aside"></ng-content>
<div>
  <ng-content></ng-content>
</div>
